import { environment } from '@env/environment'
import { OAuthModuleConfig } from 'angular-oauth2-oidc'

export const authModuleConfig: OAuthModuleConfig = {
	resourceServer: {
		allowedUrls: [environment.apiUrl, environment.issuer],
		sendAccessToken: true,
	},
}
